export const uniqueCompositionItems = (comp: any[]) => {
  const seen = new Set();


  return comp.filter((item) => {
    if (seen.has(`gpc_mldcod-${item.gpc_mldcod}`)) return false;
    if (item.gpc_mldcod) seen.add(`gpc_mldcod-${item.gpc_mldcod}`);

    if (seen.has(`gpc_cnmcod-${item.gpc_cnmcod}`)) return false;
    if (item.gpc_cnmcod) seen.add(`gpc_cnmcod-${item.gpc_cnmcod}`);

    return true;
  });
};
